export const urls = {
	set: '/rest/jpo/1.0/pluginUserProperties/set',
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setUserPropertyBody = (key: string, value: any) => ({
	key,
	value,
});
